var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpacer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 32,
    viewBox: "0 0 2 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: 1,
    y1: 32,
    x2: 0.999999,
    y2: 2.18557e-8,
    stroke: "#93AEB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacer);
export default __webpack_public_path__ + "static/media/spacer.e446a4db33f737a26c6e5699ec4b99c1.svg";
export { ForwardRef as ReactComponent };